import React from 'react';
import PropTypes from 'prop-types';
import { StarRating } from './star_rating';
import getTranslatedText from '../../helper/get_translated_text';

export const Rating = props => (
    <div className="rating-stars">
        <StarRating { ...props.starRating } />

        { props.starRating.stars.reviewCount === 0
            ? ' ' + getTranslatedText('fitting-station-finder-overview-no-reviews')
            : props.starRating.stars.average
                + ' ' + getTranslatedText('fitting-station-finder-overview-rating-out-of')
                + ' ' + props.starRating.stars.reviewCount
        }
    </div>
);

Rating.propTypes = {
    starRating: PropTypes.shape( StarRating.propTypes ).isRequired,
};
